import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OperadorasActions } from '@gestor-web/@core/store/actions';
import { OperadorasSelectors, UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { normalizeOperadora } from '@gestor-web/@core/utils';
import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { filter, map, skipWhile, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OperadoraWorkspaceGuard {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(OperadorasSelectors.selectOperadorasLoaded).pipe(
      skipWhile(loaded => !loaded),
      switchMap(() =>
        combineLatest([
          of(route.paramMap.get('id')),
          this.store.select(OperadorasSelectors.selectWorkspaceOperadoraId),
          this.store.select(OperadorasSelectors.selectWorkspaceNotFound),
          this.store.select(UserProfileSelectors.selectIsAdmin),
          this.store.select(UserProfileSelectors.selectFuncionalidadesLoaded),
          this.store.select(UserProfileSelectors.selectFuncionalidadesRegans),
          this.store.select(UserProfileSelectors.selectIsOffline),
        ]),
      ),
      map(([routeId, workspaceId, notFound, isAdmin, funcionalidadesLoaded, funcionalidadesRegans, isOffline]) => {
        if (routeId) {
          if (notFound) {
            this.store.dispatch(OperadorasActions.clearNotFound());
            this.router.navigate([isAdmin ? '/' : 'access']);
            return false;
          }
          if (workspaceId != routeId) {
            this.store.dispatch(OperadorasActions.changeSelectedOperadoraWorkspace({ cd_registro_ans: routeId }));
            return null;
          }
          // A lista pode estar carregada, mas ser a do papel (login) ou a da operadora anterior.
          if (!funcionalidadesLoaded || normalizeOperadora(funcionalidadesRegans) !== normalizeOperadora(routeId)) {
            return null;
          }
          // A lista da troca de operadora não veio: o ProfileGuard do pai não roda de novo aqui.
          if (isOffline) {
            this.router.navigate(['/offline']);
            return false;
          }
          return true;
        }

        this.router.navigate(['/']);
        return false;
      }),
      filter(ok => ok !== null),
      take(1),
    );
  }
}
